import { FeatureFlag } from './featureFlag';

// these are the default feature flag values when there would be an error with launchDarkly
export default {
  [FeatureFlag.EnablePlanningBooster]: false,
};
